export default __webpack_public_path__ + "static/media/NuvemExemplo.bd725536.svg";